'use client';
import { RootState } from '@/store/store';
import { IEmployee } from '@/types';
import { createSlice } from '@reduxjs/toolkit';

export type ResetPwdType = Pick<IEmployee, 'uid'> & {
  user_password: string
};

interface ResetPwdState {
  newCreds: ResetPwdType;
}

const initialState: ResetPwdState = {
  newCreds: { uid: '', user_password: '' },
};

export const resetPwdSlice = createSlice({
  name: 'recap',
  initialState,
  reducers: {
    setCreds: (state, selected) => {
      state.newCreds = selected.payload;
      },
    clearCreds: (state) => {
      state.newCreds = {
        uid: '',
        user_password: '',
      };
    },
  },
});

export const { setCreds, clearCreds } = resetPwdSlice.actions;
export const selectCreds = (state: RootState) => state.resetPwdSlice.newCreds;
export default resetPwdSlice.reducer;
